var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dui-book-cover",class:{ 'square': _vm.vm.isSquare }},[_c('span',{staticClass:"cover-image",style:({ 'background-image': _vm.vm.coverUrl ?
      'url(' + _vm.vm.coverUrl + ')' :
      '',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }